// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import vant from 'vant';
import ElementUI from 'element-ui'
import '../static/css/navBar.css';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use('vant');
Vue.use(ElementUI);

Vue.prototype.axios = axios;

Vue.config.productionTip = false
axios.defaults.withCredentials = true;

// router.beforeEach((to, from, next) => {
//   if(to.name==='reBaiBai'||to.name==='reBaiAbout'){
//     document.title = "热摆摆科技"
//   }else{
//     document.title ="official_website"
//   }
//   next();
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js